import { render, staticRenderFns } from "./BrowserUpdate.vue?vue&type=template&id=2851494a&scoped=true&"
import script from "./BrowserUpdate.vue?vue&type=script&lang=js&"
export * from "./BrowserUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BrowserUpdate.vue?vue&type=style&index=0&id=2851494a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851494a",
  null
  
)

export default component.exports